export const kycTransformData = data => {
  if (data.notAnOrganization) {
    return {
      notAnOrganization: data.notAnOrganization,
      documents: {
        goverment_issued_id: data.documents.goverment_issued_id,
        user_goverment_issued_id: data.documents.user_goverment_issued_id,
        signature: data.signature,
        location: data.location
      },
      registry_details: data.registry_details,
      ContactName: data.basicInformationContactName,
      user_mobile: {
        PhoneCode: data.basicInformationContactDetailsPhoneCode,
        Number: Number(data.basicInformationContactDetailsContactNumber)
      },
      user_Email: data.basicInformationContactDetailsEmail,
      Address: {
        AddressLine: data.basicInformationAddressLine,
        Country: data.basicInformationCountry,
        State: data.basicInformationState,
        City: data.basicInformationCity,
        Pincode: data.basicInformationPincode
      },
      PanId: data.basicInformationPanId,
      PersonName: data.contactDetailsPersonName,
      mobile_no: {
        PhoneCode: data.contactDetailsPhoneCode,
        ContactNumber: Number(data.contactDetailsContactNumber)
      },
      Email: data.contactDetailsEmail,
      ShortDescription: data.contactDetailsShortDescription
    }
  } else {
    return {
      notAnOrganization: data.notAnOrganization,
      documents: {
        goverment_issued_id: data.documents.goverment_issued_id,
        CompanyRegisteredAddress:
          data.documents.organizationInformationCompanyRegisteredAddress,
        CompanyTaxId: data.documents.organizationInformationCompanyTaxId,
        PanId: data.documents.organizationInformationPanId,
        DunsNumber: data.documents.organizationInformationDunsNumber,
        signature: data.signature,
        location: data.location
      },
      registry_details: data.registry_details,
      billingCompanyRegisteredAddress: data.billingCompanyRegisteredAddress,
      CompanyType: data.organizationInformationCompanyType,
      OrganizationName: data.organizationInformationOrganizationName,
      addressDetails: {
        AddressLine: data.organizationInformationAddressLine,
        Country: data.organizationInformationCountry,
        State: data.organizationInformationState,
        City: data.organizationInformationCity,
        Pincode: data.organizationInformationPincode
      },
      CompanyRegisteredAddress:
        data.organizationInformationCompanyRegisteredAddress,
      taxInfo: {
        PanId: data.organizationInformationPanId,
        CompanyTaxId: data.organizationInformationCompanyTaxId,
        DunsNumber: data.organizationInformationDunsNumber
      },
      org_mobile_no: {
        PhoneCode: data.organizationInformationPhoneCode,
        ContactNumber: Number(data.organizationInformationContactNumber)
      },
      Email: data.organizationInformationEmail,
      WebsiteLink: data.organizationInformationWebsiteLink,
      NatureOfBussiness: data.organizationInformationNatureOfBussiness,
      BillingOrganizationName: data.billingInformationOrganizationName,
      billingAddress: {
        AddressLine: data.billingInformationAddressLine,
        Country: data.billingInformationCountry,
        State: data.billingInformationState,
        City: data.billingInformationCity,
        Pincode: data.billingInformationPincode
      },
      TaxId: data.billingInformationTaxId,
      DunsNumber: data.billingInformationDunsNumber,
      PersonName: data.contactDetailsPersonName,
      billing_mobile_no: {
        PhoneCode: data.contactDetailsPhoneCode,
        ContactNumber: Number(data.contactDetailsContactNumber)
      },
      contactEmail: data.contactDetailsEmail
    }
  }
}

export const fillkycTransformData = responseData => {
  let data, basicInfo
  if (responseData.individual) {
    data = responseData.individual
    basicInfo = data.basicInfo
    return {
      checkbox: true,
      signature: data.individual_documents.signature,
      goverment_issued_id: data.individual_documents.goverment_issued_id,
      location: data.individual_documents.location,
      registry_details: basicInfo.registry_details,
      contactDetailsPersonName: basicInfo.contactDetails.PersonName,
      basicInformationAddressLine: basicInfo.Address.AddressLine,
      basicInformationCountry: basicInfo.Address.Country,
      basicInformationState: basicInfo.Address.State,
      basicInformationCity: basicInfo.Address.City,
      basicInformationPincode: basicInfo.Address.Pincode,
      basicInformationPanId: basicInfo.PanId,
      contactDetailsPhoneCode: basicInfo.contactDetails.mobile_no.PhoneCode,
      contactDetailsContactNumber:
        basicInfo.contactDetails.mobile_no.ContactNumber,
      contactDetailsEmail: basicInfo.contactDetails.Email,
      basicInformationContactName: basicInfo.ContactName,
      contactDetailsShortDescription: basicInfo.contactDetails.ShortDescription
    }
  } else {
    data = responseData.organization
    let { orgInfo, orgBillingInfo, org_documents } = data
    return {
      checkbox: true,

      goverment_issued_id: org_documents.goverment_issued_id,
      organizationInformationCompanyRegisteredAddress:
        org_documents.CompanyRegisteredAddress,
      organizationInformationCompanyTaxId: org_documents.CompanyTaxId,
      organizationInformationPanId: org_documents.PanId,
      organizationInformationDunsNumber: org_documents.DunsNumber,
      signature: org_documents.signature,
      location: org_documents.location,

      organizationInformationCompanyType: orgInfo.CompanyType,
      organizationInformationOrganizationName: orgInfo.OrganizationName,
      registry_details: orgInfo.registry_details,
      organizationInformationNatureOfBussiness: orgInfo.NatureOfBussiness,

      organizationInformationAddressLine: orgInfo.addressDetails.AddressLine,
      organizationInformationCountry: orgInfo.addressDetails.Country,
      organizationInformationState: orgInfo.addressDetails.State,
      organizationInformationCity: orgInfo.addressDetails.City,
      organizationInformationPincode: orgInfo.addressDetails.Pincode,
      organizationInformationCompanyRegisteredAddress:
        orgInfo.CompanyRegisteredAddress,

      organizationInformationPanId: orgInfo.taxInfo.PanId,
      organizationInformationCompanyTaxId: orgInfo.taxInfo.CompanyTaxId,
      organizationInformationDunsNumber: orgInfo.taxInfo.DunsNumber,

      organizationInformationPhoneCode:
        orgInfo.orgContactDetails.org_mobile_no.PhoneCode,
      organizationInformationContactNumber:
        orgInfo.orgContactDetails.org_mobile_no.ContactNumber,

      organizationInformationEmail: orgInfo.orgContactDetails.Email,
      organizationInformationWebsiteLink: orgInfo.orgContactDetails.WebsiteLink,

      billingInformationOrganizationName:
        orgBillingInfo.BillingOrganizationName,
      billingCompanyRegisteredAddress:
        orgBillingInfo.billingCompanyRegisteredAddress,

      billingInformationAddressLine: orgBillingInfo.billingAddress.AddressLine,
      billingInformationCountry: orgBillingInfo.billingAddress.Country,
      billingInformationState: orgBillingInfo.billingAddress.State,
      billingInformationCity: orgBillingInfo.billingAddress.City,
      billingInformationPincode: orgBillingInfo.billingAddress.Pincode,

      billingInformationTaxId: orgBillingInfo.TaxId,
      billingInformationDunsNumber: orgBillingInfo.DunsNumber,

      contactDetailsPersonName: orgBillingInfo.contactDetails.PersonName,
      contactDetailsPhoneCode:
        orgBillingInfo.contactDetails.billing_mobile_no.PhoneCode,
      contactDetailsContactNumber:
        orgBillingInfo.contactDetails.billing_mobile_no.ContactNumber,
      contactDetailsEmail: orgBillingInfo.contactDetails.contactEmail
    }
  }
}
